import React, { useMemo } from 'react'
import { Redirect, useParams } from 'react-router'
import { heroImages } from '../../helpers/heroimages'
import { getHeroById } from '../../selectors/getHeroById'

import './estilos.css'

//formas de trabajar con imagenes normalmente sino traigo las imagenes del public no se cargaran

// esto serviria en caso de tener un recurso estatico
// import batman from '../../assets/heroes/dc-batman.jpg' 


export const HeroScree = ({ history }) => {

    const { heroeid } = useParams()

    const hero = useMemo(() => getHeroById(heroeid), [heroeid])
    //const hero = getHeroById(heroeid) // aqui resivo toda la informacion

    //este if es para comprobar que el hero que llega esta o para evitar estas cosas > batmanxx
    //si no existe
    if (!hero) {
        return <Redirect to='/' />
    }

    const volverAlInicio = () => {

        if (history.length <= 2) {
            history.push('/')
        } else {
            history.goBack('/')
        }

    }

    const {
        superhero,
        publisher,
        alter_ego,
        first_appearance,
    } = hero


    return (
        <div className='contenedor'>

            <div className='card'>
                <div className='box' >
                    <div className='content'>
                        <div className='data'>
                            <h2>{publisher}</h2>
                            <span>{first_appearance}</span>
                            <h1>{superhero}</h1>
                            <p>
                                {alter_ego}
                            </p>
                        </div>


                        <button id='volver' onClick={volverAlInicio}>Volver</button>

                        <div id='imagen' className='animate__animated animate__fadeInLeft'>
                            <img 
                            //desde public/assets
                            //src={`../../assets/heroes/${heroeid}.jpg`} 
                            // src={batman} //importacion
                            src={heroImages(`./${ heroeid }.jpg`).default }
                            alt={superhero} />
                        </div>
                    </div>
                </div>
            </div>

        </div >
    )
}


//!useParams ==> estra los hooks que me llegan por parametro